import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './restore-warning-dialog.component.html',
  styleUrls: [],
  standalone: false,
})
export class RestoreWarningDialogComponent {
  constructor(public dialogRef: MatDialogRef<RestoreWarningDialogComponent>) {}

  continueRestore(): void {
    this.dialogRef.close(true);
  }
}
